import { useState } from "react";
import { Building2Icon, FilterIcon, SearchIcon } from "lucide-react";

import { DropDownCell } from "@/components/DropDownCell";

import { useCreateJobUpdate } from "@/hooks/mutations/useCreateJobUpdate";
import { ChipSelectOption, JobBottleneck } from "@/types";

const BOTTLENECK_OPTIONS: ChipSelectOption<JobBottleneck>[] = [
  {
    value: JobBottleneck.CUSTOMER,
    label: "Customer",
    icon: Building2Icon,
    selectedClassName:
      "border-lever-border-light bg-lever-surface-neutral text-lever-text-footnote hover:bg-lever-surface-neutral",
    iconClassName: "text-lever-text-footnote",
  },
  {
    value: JobBottleneck.SCREENING,
    label: "Screening",
    icon: FilterIcon,
    selectedClassName:
      "border-lever-border-light bg-lever-surface-neutral text-lever-text-footnote hover:bg-lever-surface-neutral",
    iconClassName: "text-lever-text-footnote",
  },
  {
    value: JobBottleneck.SOURCING,
    label: "Sourcing",
    icon: SearchIcon,
    selectedClassName:
      "border-lever-border-light bg-lever-surface-neutral text-lever-text-footnote hover:bg-lever-surface-neutral",
    iconClassName: "text-lever-text-footnote",
  },
];

// Editable bottleneck chip shared by the portfolio matrix and the dashboard.
// Reads from the job's latest update; a change writes a new job-update, and the
// mutation patches both the matrix and dashboard caches.
export const BottleneckCell = ({
  bottleneck: initialBottleneck,
  companyId,
  jobId,
}: {
  bottleneck: JobBottleneck | null;
  companyId: string;
  jobId: string;
}) => {
  /* Database CRUD Operations */
  // Update
  const { mutate: createJobUpdate } = useCreateJobUpdate();

  /* React Hooks */
  // Optimistic local value; the caches are patched on success.
  const [bottleneck, setBottleneck] = useState(initialBottleneck);

  /* Handlers */
  const handleChange = (next: JobBottleneck | null) => {
    setBottleneck(next);
    createJobUpdate({
      companyId,
      jobId,
      createJobUpdateRequest: { bottleneck: next },
    });
  };

  /* Render */
  const render = () => (
    <DropDownCell
      iconOnly
      options={BOTTLENECK_OPTIONS}
      placeholder="Set bottleneck"
      value={bottleneck}
      onChange={handleChange}
    />
  );

  return render();
};
